// eslint-disable-next-line max-classes-per-file
import { calculateLeftDays } from "@/helpers/medicalDocumentsFunctions";
import { reformatDate } from "../../helpers/workWithDates";

export class MedicalAnalyse {
    constructor(data) {
        const { workerAnalysis } = data;
        this.id = data.id;
        this.type_id = data.type_id;
        this.name = data.name;

        this.expireInDays = data.expire_in_days;

        if (!workerAnalysis) {
            this.status = "required";
        }

        if (workerAnalysis) {
            this.status = "exist";

            if (workerAnalysis.expireSoon) {
                this.status = "expiring";
            }
            if (workerAnalysis.expired) {
                this.status = "expired";
            }

            if (workerAnalysis.expirationDate) {
                const daysLeft = calculateLeftDays(workerAnalysis.expirationDate);

                this.expireInfo = {
                    expirationDate: reformatDate(workerAnalysis.expirationDate),
                    daysLeft: daysLeft >= 0 ? daysLeft : 0,
                };
            }
        }
    }
}

export class MedicalAnalysesGroup {
    constructor(data) {
        this.id = data.id;
        this.name = data.name;
        this.analyses = data.analyses.map((analyse) => new MedicalAnalyse(analyse));
    }
}
